function base() {
	initSmoothScrollAnimation();
	initRevealOnScrollAnimations();
	// Import and initialize modal handler
	import('../partials/modal');

	// Add polyfill for browsers without dialog element support
	if (typeof HTMLDialogElement !== 'function') {
		console.log('Dialog element is not supported by this browser. Using polyfill.');
	}
}
